import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Logo from 'modules/core/components/Logo'
import { useGetCurrentSession } from 'modules/core/hooks/useGetCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { useHasOnboardingProcess } from '../hooks/useHasOnboardingProcess'

const OnboardingWelcomePage = () => {
  const { navigation } = useNavigation()
  const { hasOnboarding, loading: loadingOnboardingProcess } = useHasOnboardingProcess()
  const { company, loading: loadingCompany } = useGetCurrentSession()
  const loading = loadingOnboardingProcess || loadingCompany

  const info = hasOnboarding
    ? {
        path: navigation.employee_onboarding.onboardingTasks.fullPath(),
        label: i18n.t('employees.onboarding_welcome.go_to_onboarding'),
        description: i18n.t('employees.onboarding_welcome.go_to_onboarding_description'),
      }
    : {
        path: navigation.profile.personal.fullPath(),
        label: i18n.t('employees.onboarding_welcome.fill_your_info'),
        description: i18n.t('employees.onboarding_welcome.fill_your_info_description'),
      }

  return (
    <ResponsivePage.Body loading={loading} variant="full" error={null}>
      <Box paddingLeft="s80" paddingTop="s120" paddingRight="s120" gap="s24">
        {company && <Logo companyLogo={company.logo} alt={company.name} height={70} />}
        <Text size="800" weight="semibold" color="grey1000">
          {i18n.t('employees.onboarding_welcome.welcome_to', {
            name: company?.name,
          })}
        </Text>
        <Box paddingRight="s48">
          <Text size="400" color="grey800">
            {info.description}
          </Text>
        </Box>
        <Button.Router type="primary" to={info.path}>
          {info.label}
        </Button.Router>
      </Box>
    </ResponsivePage.Body>
  )
}

export default OnboardingWelcomePage
